import { useEffect, useState } from "react";
import { User, Role } from "../../types/api";
import {
  Box,
  Button,
  Paper,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Add } from "@mui/icons-material";
import { listUsers, updateUser } from "../../api/ีuser";

export default function UserListPage() {
  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const navigate = useNavigate();

  const load = async () => {
    // โหลด users + roles จาก API
    const usersRes = await listUsers();
    setUsers(usersRes);

    // roles จะดึงมาก่อนก็ได้ หรือ embed ใน user
    // สมมติคุณมี API แยก listRoles
    // const rolesRes = await listRoles();
    // setRoles(rolesRes);
    // 🚨 ตัวอย่างนี้ผม fix ไว้ตรงนี้
    setRoles([
      { id: 1, name: "ผู้จัดการระบบ", code: "ADMIN" },
      { id: 2, name: "ผู้จัดการการเดินรถ", code: "MANAGER" },
      { id: 3, name: "ผู้ตรวจสอบข้อมูล", code: "INSPECTOR" },
    ]);
  };

  useEffect(() => {
    load();
  }, []);

  const handleRoleChange = async (userId: number, roleId: number) => {
    try {
      await updateUser(userId, { roleId });
      setUsers((prev) =>
        prev.map((u) => (u.id === userId ? { ...u, roleId } : u))
      );
    } catch (err) {
      console.error("เปลี่ยน Role ไม่สำเร็จ", err);
    }
  };

  const columns: GridColDef[] = [
    { field: "username", headerName: "ชื่อผู้ใช้", flex: 1, minWidth: 150 },
    {
      field: "role",
      headerName: "สิทธิ์การใช้งาน",
      flex: 1,
      minWidth: 200,
      renderCell: ({ row }) => (
        <Select
          size="small"
          value={row.roleId ?? ""}
          onChange={(e) =>
            handleRoleChange(row.id, Number(e.target.value))
          }
          sx={{ minWidth: 180 }}
        >
          {roles.map((role) => (
            <MenuItem key={role.id} value={role.id}>
              {role.name}
            </MenuItem>
          ))}
        </Select>
      ),
    },
  ];

  return (
    <Box>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">จัดการผู้ใช้งาน</Typography>
        {/* <Button
          variant="contained"
          onClick={() => navigate("/users/create")}
          sx={{ backgroundColor: "#FEDC00", color: "#000" }}
          startIcon={<Add />}
        >
          เพิ่มผู้ใช้
        </Button> */}
      </Box>

      {/* DataGrid */}
      <Paper sx={{ height: 500, width: "100%", p: 1 }}>
        <DataGrid
          rows={users}
          columns={columns}
          pageSizeOptions={[5, 10, 20]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          disableRowSelectionOnClick
          getRowId={(row) => row.id}
          sx={{
            border: 0,
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#FEDC00",
              color: "#000",
              fontWeight: "bold",
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#FFFDE7",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#FFF59D",
            },
          }}
        />
      </Paper>
    </Box>
  );
}
